import {React, observer, observable, computed, IDisposer, useLocalStore, useEffect, useAsObservableSource, classNames} from '@api'
import {SvgPathUtils, TldrawApp, useTldrawApp} from '@modules/whiteboard'
import {HighlighterShape} from './'
import {ShapeComponentStore} from '@modules/whiteboard/shapes/ShapeComponentStore'
import {SVGContainer, TLComponentProps} from '@tldraw/core'
import * as css from './Highlighter.css'

/// region Store

export class HighlighterComponentStore extends ShapeComponentStore<HighlighterShape, any> {
  constructor(public props: MyProps & { app: TldrawApp }) {
    super(props)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @computed get pointsPath() {
    const {shape: {points}} = this
    return SvgPathUtils.getCurvedPathForPoints(points)
  }
}

export const HighlighterComponentStoreContext = React.createContext<HighlighterComponentStore>(null)
export const useHighlighterComponentStore = () => React.useContext(HighlighterComponentStoreContext)

/// endregion

/// region Components

interface MyProps extends TLComponentProps<HighlighterShape> {
  className?: string
}

export const HighlighterComponent = observer<MyProps, any>(function HighlighterComponent({className, ...props}, ref) {
  const app = useTldrawApp(),
    obsProps = useAsObservableSource({...props, app}),
    store = useLocalStore(() => new HighlighterComponentStore(obsProps)),
    {props: {events}, dataAttributes, shapeStyle: {strokeColor, opacity, strokeWidth, backgroundColor}, pointsPath} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <SVGContainer {...events}
                  className={classNames(css.shape, className)}
                  {...dataAttributes}
                  ref={ref}>
      <path
        d={pointsPath}
        strokeWidth={strokeWidth * 16}
        stroke={strokeColor}
        fill={backgroundColor}
        pointerEvents="all"
        strokeLinejoin="round"
        strokeLinecap="round"
        opacity={opacity}
      />
    </SVGContainer>
  )
}, {forwardRef: true})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/highlighter/HighlighterComponent.tsx